import {
  colorUseCases,
  getColorScaleValueByUseCase,
  styled,
} from "@vitality-ds/system";

import DocsFlex from "../../../../../DocsFlex";

const { backgrounds } = colorUseCases;

export const Image = styled("img", {
  width: "110px",
});

export const LogoFlex = styled(DocsFlex, {
  a: {
    textDecoration: "none",
    fontSize: 0,
    margin: "-$md",
    padding: "$sm $md",
    display: "flex",
    borderRadius: "$default",
    border: "none",
    ".designSystemText > span": {
      /**
       * Position the words "Design System" optically with the logo
       */
      marginTop: "calc($sm * -0.5)",
      fontSize: 24,
      fontFamily: "ABC Whyte",
      fontWeight: 400,
      marginLeft: "$xs",
    },
    "&:hover": {
      backgroundColor: getColorScaleValueByUseCase(
        "neutral",
        backgrounds.uiElement_hovered
      ),
    },
    "&::selection": {
      backgroundColor: getColorScaleValueByUseCase(
        "neutral",
        backgrounds.uiElement_active
      ),
    },
    "&:focus": {
      boxShadow: "0 0 0 $space$outlineWidth $colors$brand7",
      outline: "none",
    },
  },
  marginTop: 4,
});
